import { Auth } from 'aws-amplify';
import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import { DateTime } from 'luxon';
import { fetchUrl } from 'src/constants/fetch-url';
import { error } from 'src/constants/messages';
import { Tenant, TenantListData } from 'src/data-type/data-types';

const sender = async (fetcher: (config: AxiosRequestConfig) => Promise<AxiosResponse>) => {
  try {
    const jwtToken = (await Auth.currentSession()).getIdToken().getJwtToken();
    const headers = { headers: { Authorization: jwtToken } };
    return await fetcher(headers);
  } catch (err) {
    if (err === error.authError) {
      console.log(err);
      window.location.reload();
    }
    if (err instanceof AxiosError) {
      return { status: err.response?.status, data: err.response?.data };
    } else console.log(err);

    return;
  }
};

const list = async () => {
  return await sender((config: AxiosRequestConfig<TenantListData>) =>
    axios<TenantListData>(fetchUrl.listTenant, config)
  );
};

const add = async (rawData: Tenant) => {
  const d = rawData.expirationDate ? convertISOLocal(rawData.expirationDate) : null;
  const data: Tenant = { ...rawData, id: Number(rawData.id), expirationDate: d };
  return await sender((config: AxiosRequestConfig<Tenant>) =>
    axios({ method: 'post', url: fetchUrl.registerTenant, data: data, ...config })
  );
};

const update = async (rawData: Tenant) => {
  const d = rawData.expirationDate ? convertISOLocal(rawData.expirationDate) : null;
  const data: Tenant = { ...rawData, expirationDate: d };
  return await sender((config: AxiosRequestConfig<Tenant>) =>
    axios({ method: 'put', url: fetchUrl.registerTenant, data: data, ...config })
  );
};

const convertISOLocal = (rawDate: string) => {
  let d: string | null = null;
  if (rawDate) {
    d = DateTime.fromISO(rawDate).toISO();
  }
  return d;
};

export const tenantData = { list, add, update };
